export const AWS_LOCATION_CONFIG = {
   region: import.meta.env.VITE_APP_PLACES_REGION,
   mapName: import.meta.env.VITE_APP_MAP_NAME,
   placesIndex: import.meta.env.VITE_APP_PLACES_INDEX,
   apiKey: import.meta.env.VITE_APP_PLACES_API_KEY,
} as const;

export function getMapStyleUrl(): string {
   const { region, mapName, apiKey } = AWS_LOCATION_CONFIG;
   return `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`;
}
